// src/utils/logout.ts
import axios from "axios";
import { baseUrl } from "../constants";
import { messaging } from "../notifications/firebase";
import { deleteToken, isSupported } from "firebase/messaging";

/**
 * Logs the user out:
 * - best-effort server call (ignores failure)
 * - clears tokens from BOTH localStorage & sessionStorage
 * - revokes FCM token if supported
 * - broadcasts "auth-token-changed" so App updates immediately
 */
export async function logOutRequest(): Promise<void> {
  try {
    const token =
      localStorage.getItem("accessToken") ||
      sessionStorage.getItem("accessToken");

    // Best-effort server logout (don't block on errors)
    if (token) {
      try {
        await axios.post(
          `${baseUrl}/auth/logout`,
          {},
          { headers: { Authorization: `Bearer ${token}` } }
        );
      } catch {
        // ignore
      }
    }
  } finally {
    // Revoke push token (best effort)
    try {
      const supported = await isSupported();
      if (supported) {
        await deleteToken(messaging);
      }
    } catch {
      // ignore
    }

    // Clear auth tokens from BOTH storages
    localStorage.removeItem("accessToken");
    sessionStorage.removeItem("accessToken");

    // Tell the app the token changed so guards re-evaluate
    window.dispatchEvent(new Event("auth-token-changed"));
  }
}
